import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../config.js';

const Users = ({ onBack }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchName, setSearchName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const usersPerPage = 20;

  useEffect(() => {
    fetchUsers();
  }, [currentPage, searchName]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('userToken');
      
      const response = await axios.get(`${apiBaseUrl}/api/admin/users`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: {
          page: currentPage,
          limit: usersPerPage,
          searchName: searchName
        }
      });

      if (response.data.success) {
        setUsers(response.data.users);
        setTotalPages(response.data.pagination.totalPages);
        setTotalUsers(response.data.pagination.totalUsers);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      alert('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchName(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const getUserTypeLabel = (userType) => {
    switch(userType) {
      case 'admin': return 'Administrador';
      case 'agent': return 'Agente Inmobiliario';
      case 'individual': return 'Individual';
      default: return userType || 'N/A';
    }
  };

  const getUserTypeBadgeColor = (userType) => {
    switch(userType) {
      case 'admin': return '#dc3545';
      case 'agent': return '#764ba2';
      case 'individual': return '#28a745';
      default: return '#6c757d';
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '1400px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        marginBottom: '30px',
        flexWrap: 'wrap',
        gap: '15px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ 
            margin: '0 0 10px 0', 
            fontSize: '2rem', 
            fontWeight: '700',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            👥 Usuarios Registrados
          </h1>
          <p style={{ margin: 0, color: '#6c757d', fontSize: '1rem' }}>
            Total: {totalUsers} usuarios
          </p>
        </div>
      </div>

      {/* Search Filter */}
      <div style={{
        background: 'white',
        padding: '25px',
        borderRadius: '15px',
        boxShadow: '0 2px 20px rgba(0, 0, 0, 0.08)',
        marginBottom: '25px'
      }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr auto',
          gap: '20px',
          alignItems: 'end'
        }}>
          <div>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontWeight: '600',
              color: '#495057',
              fontSize: '0.95rem'
            }}>
              🔍 Buscar por Nombre o Apellido
            </label>
            <input
              type="text"
              value={searchName}
              onChange={handleSearch}
              placeholder="Ingresá nombre o apellido..."
              style={{
                width: '100%',
                padding: '12px 15px',
                borderRadius: '8px',
                border: '2px solid #dee2e6',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#667eea';
                e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#dee2e6';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>
          
          {searchName && (
            <button
              onClick={() => {
                setSearchName('');
                setCurrentPage(1);
              }}
              style={{
                padding: '12px 20px',
                background: '#f8f9fa',
                color: '#6c757d',
                border: '2px solid #dee2e6',
                borderRadius: '8px',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#e9ecef';
                e.target.style.borderColor = '#adb5bd';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#f8f9fa';
                e.target.style.borderColor = '#dee2e6';
              }}
            >
              Limpiar
            </button>
          )}
        </div>
      </div>

      {/* Users Table */}
      <div style={{
        background: 'white',
        borderRadius: '15px',
        boxShadow: '0 2px 20px rgba(0, 0, 0, 0.08)',
        overflow: 'hidden'
      }}>
        {loading ? (
          <div style={{ 
            padding: '60px', 
            textAlign: 'center',
            color: '#6c757d'
          }}>
            <div style={{
              width: '50px',
              height: '50px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #667eea',
              borderRadius: '50%',
              margin: '0 auto 20px auto',
              animation: 'spin 1s linear infinite'
            }}></div>
            <p style={{ margin: 0, fontSize: '1.1rem' }}>Cargando usuarios...</p>
          </div>
        ) : users.length === 0 ? (
          <div style={{ 
            padding: '60px', 
            textAlign: 'center',
            color: '#6c757d'
          }}>
            <p style={{ margin: 0, fontSize: '1.2rem' }}>
              {searchName ? '🔍 No se encontraron usuarios con ese nombre' : '👥 No hay usuarios registrados'}
            </p>
          </div>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '0.95rem'
              }}>
                <thead>
                  <tr style={{ 
                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                    color: 'white'
                  }}>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Nombre</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Apellido</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Email</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Teléfono</th>
                    <th style={{ padding: '16px', textAlign: 'center', fontWeight: '600' }}>Tipo</th>
                    <th style={{ padding: '16px', textAlign: 'center', fontWeight: '600' }}>💎 Créditos Premium</th>
                    <th style={{ padding: '16px', textAlign: 'center', fontWeight: '600' }}>🏠 Total Valuaciones</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Fecha Registro</th>
                    <th style={{ padding: '16px', textAlign: 'left', fontWeight: '600' }}>Último Acceso</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, index) => (
                    <tr 
                      key={user._id}
                      style={{ 
                        borderBottom: '1px solid #f0f0f0',
                        transition: 'background 0.2s ease',
                        background: index % 2 === 0 ? 'white' : '#f8f9fa'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#f0f7ff'}
                      onMouseLeave={(e) => e.currentTarget.style.background = index % 2 === 0 ? 'white' : '#f8f9fa'}
                    >
                      <td style={{ padding: '14px', fontWeight: '600', color: '#2c3e50' }}>
                        {user.name || 'N/A'}
                      </td>
                      <td style={{ padding: '14px', color: '#495057' }}>
                        {user.lname || 'N/A'}
                      </td>
                      <td style={{ padding: '14px', color: '#495057' }}>
                        {user.email}
                      </td>
                      <td style={{ padding: '14px', color: '#495057' }}>
                        {user.phone || 'N/A'}
                      </td>
                      <td style={{ padding: '14px', textAlign: 'center' }}>
                        <span style={{
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          color: 'white',
                          background: getUserTypeBadgeColor(user.userType),
                          display: 'inline-block'
                        }}>
                          {getUserTypeLabel(user.userType)}
                        </span>
                      </td>
                      <td style={{ padding: '14px', textAlign: 'center' }}>
                        <span style={{
                          padding: '8px 14px',
                          borderRadius: '20px',
                          fontSize: '0.9rem',
                          fontWeight: '700',
                          color: 'white',
                          background: (user.premiumCredits || 0) > 0 
                            ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' 
                            : '#95a5a6',
                          display: 'inline-block',
                          minWidth: '45px',
                          boxShadow: (user.premiumCredits || 0) > 0 ? '0 2px 10px rgba(240, 147, 251, 0.3)' : 'none'
                        }}>
                          {user.premiumCredits || 0}
                        </span>
                      </td>
                      <td style={{ padding: '14px', textAlign: 'center' }}>
                        <span style={{
                          padding: '8px 14px',
                          borderRadius: '20px',
                          fontSize: '0.9rem',
                          fontWeight: '700',
                          color: 'white',
                          background: (user.totalValuations || 0) > 0 
                            ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                            : '#bdc3c7',
                          display: 'inline-block',
                          minWidth: '45px',
                          boxShadow: (user.totalValuations || 0) > 0 ? '0 2px 10px rgba(102, 126, 234, 0.3)' : 'none'
                        }}>
                          {user.totalValuations || 0}
                        </span>
                      </td>
                      <td style={{ padding: '14px', color: '#495057' }}>
                        {user.createdAt ? new Date(user.createdAt).toLocaleDateString('es-AR', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 'N/A'}
                      </td>
                      <td style={{ padding: '14px', color: '#495057' }}>
                        {user.lastLogin ? new Date(user.lastLogin).toLocaleDateString('es-AR', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : 'Nunca'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{ 
                padding: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                borderTop: '2px solid #f0f0f0'
              }}>
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={currentPage === 1}
                  style={{
                    padding: '10px 20px',
                    background: currentPage === 1 ? '#e9ecef' : 'linear-gradient(135deg, #667eea, #764ba2)',
                    color: currentPage === 1 ? '#6c757d' : 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  ← Anterior
                </button>

                <span style={{ 
                  padding: '10px 15px',
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: '0.95rem'
                }}>
                  Página {currentPage} de {totalPages}
                </span>

                <button
                  onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: '10px 20px',
                    background: currentPage === totalPages ? '#e9ecef' : 'linear-gradient(135deg, #667eea, #764ba2)',
                    color: currentPage === totalPages ? '#6c757d' : 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Siguiente →
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Users;

